import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, getPayMethods } from './modules'
import { queryIapConfig } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const Checkout = Loadable({
    loader: () => import('./Checkout'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          checkoutState: state.checkoutState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          getPayMethods,
          queryIapConfig,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/checkout'
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Checkout {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
